import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { FaIconSharedModule } from './../../atoms/fa.icon/fa.icon.module';
import { AddToCalendarSharedComponent } from './add.to.calendar.component';

@NgModule({
    declarations: [
        AddToCalendarSharedComponent
    ],
    imports: [
        CommonModule,
        FaIconSharedModule
    ],
    exports: [
        AddToCalendarSharedComponent
    ]
})

export class AddToCalendarSharedModule {}
